import { all, call, put, takeLatest } from 'redux-saga/effects'

import { callApiAsync } from 'services/api/callAPIAsync'
import { delay } from '../../../global/helpers'
import { setUser } from '../../../services/user/reducer'
import { lostCard, setError, setLoading, setSuccess } from './reducer'

function* lostCardCallSaga() {
    yield all([put(setError(null)), put(setSuccess(false)), put(setLoading(true))])

    const { error } = yield call(callApiAsync, 'loyaltyProgramBlock')
    if (error) {
        yield put(setError({ internal: true, message: error }))
    }
    yield all([put(setError(null)), put(setLoading(false)), put(setSuccess(true)), put(setUser(data))])
    yield delay()
    yield put(setSuccess(false))
}

export default function* lostCardSaga() {
    yield all([takeLatest(lostCard.type, lostCardCallSaga)])
}
